"use client";
export {
    PostDataProvider as ArticleDataProvider,
    usePostData as useArticleData,
    usePostDataOptional as useArticleDataOptional,
    type PostDataContextValue as ArticleDataContextValue,
} from "@/views/post/context/PostDataContext";
